import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

function ReportButtonResetTags({ onConfirm }) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    // TODO: Implement reset tags logic
    setOpen(false);
    onConfirm();
  };

  return (
    <>
      <Button variant="outlined" onClick={handleOpen}>
        Reset Tags
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Confirm Reset Tags</DialogTitle>
        <DialogContent>
          <p>Are you sure you want to reset all tags?</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleConfirm} autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ReportButtonResetTags;
